import { styled } from "styled-components";

export const CompanyInfoSection = styled.div`
  width: 100%;
  margin-top: 80px;
  border-top: 1px solid #e0e0e0;
`;

export const CompanyInfoContainer = styled.div`
  max-width: 1600px;
  margin: 0 auto;
  padding: 40px 120px;
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media (max-width: 768px) {
    padding: 24px 20px;
    gap: 24px;
  }
`;

export const TopInfo = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const PrivacyPolicy = styled.a`
  font-size: 14px;
  color: #666;
  text-decoration: none;
  padding: 8px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const CompanyDetails = styled.div`
  width: 100%;
  margin-top: 20px;
  font-size: 13px;
  color: #666;
  line-height: 1.8;

  @media (max-width: 768px) {
    margin-top: 16px;
    font-size: 12px;
    line-height: 1.6;
  }
`;

export const Copyright = styled.div`
  font-size: 13px;
  color: #999;

  @media (max-width: 768px) {
    margin-top: 16px;
  }
`;

export const CompanyLogo = styled.img`
  height: 40px;
`;

export const CompanyContact = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (max-width: 768px) {
    gap: 4px;
  }
`;

export const ContactNumber = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #333;
`;

export const BusinessHours = styled.div`
  font-size: 14px;
  color: #666;
`;

export const PolicyLink = styled.a`
  font-size: 14px;
  color: #666;
  text-decoration: none;
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  transition: all 0.3s ease;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background-color: #f5f5f5;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 6px 8px;
  }
`;
